module.exports = __webpack_public_path__ + "img/globe.76d569d6.svg";